<template>
  <!--消息模板分类-->
  <category></category>
</template>

<script>
import category from '@/components/package/category.vue';
export default {
  components: {
    category
  },
  name: 'msgtplCate'
};
</script>

<style scoped>

</style>
